import schedulesViewStateStore from "../../store/store";
import { IOpenShiftEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { ObservableMap } from "mobx";
import { IPreviewSchedulePageStore } from "../../../../previewSchedulePage";
import { SchedulesViewStateStore } from "../../store/schema/SchedulesViewStateStore";

export default mutatorAction('DELETE_OPEN_SHIFTS_IN_VIEW', function deleteOpenShiftsInView(
    openShiftsToDelete: IOpenShiftEntity[],
    viewState?: SchedulesViewStateStore | IPreviewSchedulePageStore
) {
    let openShifts: ObservableMap<string, IOpenShiftEntity> = viewState ? viewState.openShiftsInView : schedulesViewStateStore().openShiftsInView;
    for (let i = 0; i < openShiftsToDelete.length; i++) {
        openShifts.delete(openShiftsToDelete[i].id);
    }
});
